import { debounce as debounceFn } from './debounce';

/** Prints the runtime for the method every time it's called. */
export function time(
  target: any,
  propertyKey: any,
  descriptor: PropertyDescriptor
) {
  const originalFunction = descriptor.value;
  descriptor.value = function () {
    console.time(originalFunction.name);
    const returnValue = originalFunction.apply(this, arguments);
    console.timeEnd(originalFunction.name);
    return returnValue;
  };
}

/** Returns a decorator that debounces the method with the given wait time. */
export function debounce(waitTimeMs: number) {
  return function debounceDecorator(
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    descriptor.value = debounceFn(descriptor.value, waitTimeMs, true);
  };
}
